import React, { createContext, useState, useEffect, useContext } from "react";

export const DepartmentContext = createContext();

export const DepartmentProvider = ({ children }) => {
  const [departments, setDepartments] = useState([]);
  const apiUrl = process.env.REACT_APP_MONGO_URL;

  useEffect(() => {
    fetch(`${apiUrl}/api/departments`)
      .then((response) => response.json())
      .then((data) => {
        setDepartments(data);
      })
      .catch((error) => {
        console.error("Hata:", error);
      });
  }, [apiUrl]);

  const addDepartment = (newDepartment) => {
    fetch(`${apiUrl}/api/departments/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newDepartment),
    })
      .then((response) => response.json())
      .then((data) => {
        setDepartments((prev) => [...prev, data]);
      })
      .catch((error) => {
        console.error("Ekleme hatası:", error);
      });
  };

  const updateDepartment = (id, updatedData) => {
    fetch(`${apiUrl}/api/departments/update/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedData),
    })
      .then((response) => response.json())
      .then((updatedDepartment) => {
        setDepartments((prev) =>
          prev.map((department) =>
            department._id === id ? updatedDepartment : department
          )
        );
      })
      .catch((error) => {
        console.error("Güncelleme hatası:", error);
      });
  };

  const deleteDepartment = (id) => {
    // Önce UI'de listeyi filtrele
    setDepartments((prev) =>
      prev.filter((department) => department._id !== id)
    );

    // API isteği gönder
    fetch(`${apiUrl}/api/departments/${id}`, {
      method: "DELETE",
    }).catch((error) => {
      console.error("Silme hatası:", error);
    });
  };

  return (
    <DepartmentContext.Provider
      value={{ departments, addDepartment, deleteDepartment, updateDepartment }}
    >
      {children}
    </DepartmentContext.Provider>
  );
};

export const useDepartments = () => useContext(DepartmentContext);
